"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("./convert-report-from-results/convert-report-from-results.component");
require("./create-empty-report/create-empty-report.component");
require("./create-report-sidebar/create-report-sidebar.component");
require("./import-report/import-report.component");
var create_report_html_1 = __importDefault(require("./create-report.html"));
require("./create-report.less");
(function (module) {
    'use strict';
    module.factory('prCreateReportModal', [
        'qstrap.modal',
        'prOverrideTrigger',
        'pr.OVERRIDE_EVENTS',
        function (modal, triggerOverrides, OVERRIDE_EVENTS) {
            return {
                show: function () {
                    var createReportMessage = triggerOverrides({
                        event: OVERRIDE_EVENTS.CREATE_REPORT_MESSAGE,
                        data: 'CREATE_A_REPORT',
                        sync: true
                    });
                    var createReportController = triggerOverrides({
                        event: OVERRIDE_EVENTS.CREATE_REPORT_CONTROLLER,
                        data: 'prCreateReportController',
                        sync: true
                    });
                    var createReportTemplate = triggerOverrides({
                        event: OVERRIDE_EVENTS.CREATE_REPORT_TEMPLATE,
                        data: create_report_html_1.default,
                        sync: true
                    });
                    return modal({
                        show: true,
                        className: 'create-report',
                        title: '<i class="icon icon-plus"></i><span translate>' + createReportMessage + '</span>',
                        contentTemplate: createReportTemplate,
                        controller: createReportController,
                        buttons: [
                            '<button class="btn btn-success"'
                                + 'ng-class="{disabled: $ctrl.creating || !$ctrl.formComplete()}"'
                                + 'ng-click="$ctrl.createReport();" translate>CREATE</button>',
                            '<button class="btn btn-hover" ng-click="close()" translate>CANCEL</button>'
                        ]
                    });
                }
            };
        }
    ]);
}(angular.module('qualtrics.pr')));
